<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Graphic Panels,FiberLAST Embedment"></Breadcrumbs>
    <b-row class="image-slider-container">
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Digitally-printed fiberglass embedment</div><br>
        <div>FiberLAST embedded signs are full-color graphics digitally printed to paper, and then embedded in ultra-
          violet resistant resins, which are reinforced with fiberglass. This material is a time proven product for
          exterior interpretive signage and is used throughout the country. FiberLAST signs are .090" or 1/8" thick
          and require a frame with a backing. They are somewhat flexible and can be installed in frames without
          requiring headroom. They carry a ten-year warranty in exterior conditions.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <ImageSlider :images="images" class="image-slider"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded01.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded02.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded03.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded04.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded05.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded06.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded07.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded08.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded09.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded10.jpg'),
          require('@/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded11.jpg')
        ],
        type: Array
      }
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'FiberLAST Embedment'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/Fiberlast.vue